module.exports = __webpack_public_path__ + "img/client-login.caaf5539.jpg";